import { Button, InformationCircleIcon } from "@porchpass/ui";

type InfoIconButtonProps = {
  onClick?: () => void;
  marginLeft?: string;
  marginRight?: string;
  className?: string;
  "aria-label"?: string;
  tabIndex?: number;
  "data-testid"?: string;
};

export function InfoIconButton({
  onClick,
  marginLeft,
  marginRight,
  className,
  "aria-label": ariaLabel = "More information",
  tabIndex,
  "data-testid": dataTestId,
}: InfoIconButtonProps) {
  return (
    <Button
      type="button"
      variant="ghost"
      size="icon-sm"
      onClick={onClick}
      aria-label={ariaLabel}
      tabIndex={tabIndex}
      className={className}
      style={{ marginLeft, marginRight }}
      data-testid={dataTestId}
    >
      <InformationCircleIcon size={12} />
    </Button>
  );
}
